import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import SyncIcon from '@mui/icons-material/Sync';
import ApprovalIcon from '@mui/icons-material/HowToReg';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import DescriptionIcon from '@mui/icons-material/Description';
import FolderIcon from '@mui/icons-material/Folder';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import ChatIcon from '@mui/icons-material/Chat';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import RemoveIcon from '@mui/icons-material/Remove';

const commonIconStyle = {
  fontSize: 20,
  color: '#1976d2',
  verticalAlign: 'middle',
};

const iconLibrary = {
  edit: <EditIcon sx={commonIconStyle} />,
  folder: <FolderIcon sx={commonIconStyle} />,
  view: <VisibilityIcon sx={commonIconStyle} />,
  delete: <DeleteIcon sx={commonIconStyle} />,
  cancel: <CancelIcon sx={commonIconStyle} />,
  close: <CloseIcon sx={commonIconStyle} />,
  sync: <SyncIcon sx={commonIconStyle} />,
  approval: <ApprovalIcon sx={commonIconStyle} />,
  add: <AddIcon sx={commonIconStyle} />,
  save: <SaveIcon sx={commonIconStyle} />,
  copy: <FileCopyIcon sx={commonIconStyle} />,
  document: <DescriptionIcon sx={commonIconStyle} />,
  editPassword: <VpnKeyIcon sx={commonIconStyle} />,
  statusUpdate: <AutorenewIcon sx={commonIconStyle} />,
  chatIcon: <ChatIcon sx={commonIconStyle} />,
  doneIcon: <TaskAltIcon sx={commonIconStyle} />,
  remove:<RemoveIcon sx={commonIconStyle} />

};

export default iconLibrary;
